<script>
import SelectButton from 'primevue/selectbutton';
import BaseVolanInput from './BaseVolanInput';
export default {
  name: 'VolanSelectButton',
  components: {SelectButton},
  extends: BaseVolanInput,
  inheritAttrs: false,
  props: {
    optionLabel: {
      type: String,
      default: 'text',
    },
    optionValue: {
      type: String,
      default: 'value',
    }
  },
  data() {
    return {
    };
  },
  computed: {

  },
  watch: {
    value() {
      setTimeout(()=>{
        this.$el?.querySelector('.p-highlight')?.blur();
      }, 10);
    }
  }
};
</script>

<template>
  <SelectButton :id="computedId"
                :optionLabel="optionLabel"
                :optionValue="optionValue"
                :value="value"
                v-bind="$attrs"
                v-on="$listeners"
  />
</template>